import React, { useState, useEffect } from 'react'
import { FilterCheckBox } from '../components/filters'
import { IUiTableConfig } from '../components'

type IUseMultiSelectTableInput<T> = {
	items: Array<T>
	isEnabled: boolean
	onMultiSelect?: (selectedItems: Array<T>) => void
	initialSelectedRowIndexes?: Array<number>
}

export function useMultiSelectTable<T extends Record<string, any> | null = any>(
	{
		items,
		isEnabled = false,
		onMultiSelect,
		initialSelectedRowIndexes
	}: IUseMultiSelectTableInput<T>
) {
	const [selectAllRows, setSelectAllRows] = useState<boolean>(false)
	const [selectedRows, setSelectedRows] = useState<Array<boolean>>([])
	const [selectedRowIndexes, setSelectedRowIndexes] = useState<Array<number>>(initialSelectedRowIndexes ?? [])
	//console.log('useMultiSelectTable', { initialSelectedRowIndexes, selectedRowIndexes, selectedRows, items })

	const multiSelectConfig: IUiTableConfig<T> = {
		key: 'selection-index',
		title: 'selection-index',
		classesToAdd: {
			th: 'text-center',
			td: 'text-center'
		},
		headCellFormatter: ({ configItem }) => {
			return <div>
				<FilterCheckBox
					isDisabled={!items?.length}
					value={selectAllRows}
					setValue={(value) => {
						setSelectedRows((prevState) => {
							const arr: Array<boolean> = new Array(items.length).fill(value)
							//console.log('FilterCheckBox: selectAllRows:: ', { prevState, arr, value })
							return arr
						})

						setSelectAllRows(value)
					}}
				/>
			</div>
		},
		rowCellFormatter: ({ rowData, rowIndex }) => {
			return <>
				<div>
					<FilterCheckBox
						value={selectedRows[rowIndex]}
						setValue={(value) => {
							setSelectedRows(prevState => {
								const newState = [...prevState]
								newState[rowIndex] = value

								return newState
							})
						}}
					/>
				</div>
			</>
		}
	}

	useEffect(() => {
		if (isEnabled) {
			setSelectedRows((prevState) => {
				const initValue = false
				// const arr: Array<boolean> = new Array(items.length).fill(initValue)

				const arr: Array<boolean> = items.map((item, index) => {
					if (!initialSelectedRowIndexes || !initialSelectedRowIndexes.length) return initValue
					if (item?.id) return initialSelectedRowIndexes.includes(item?.id)
					return initialSelectedRowIndexes.includes(index)
				})

				//console.log('useEffect onItemsChanged: selectAllRows:: ', { items, arr, initValue })
				return arr
			})
		}
	}, [items, initialSelectedRowIndexes])

	useEffect(() => {
		if (isEnabled) {
			setSelectAllRows(prevVal => {
				return selectedRows.length > 0 && selectedRows.every(item => item)
			})

			if (onMultiSelect) {
				const _selectedItems: Array<T> = []
				const _selectedRowIndexes: Array<number> = []

				selectedRows.forEach((item, i) => {
					if (item) {
						_selectedItems.push(items?.[i])
						_selectedRowIndexes.push(i)
					}
				})

				setSelectedRowIndexes(_selectedRowIndexes)
				onMultiSelect(_selectedItems)
			}
		}
	}, [selectedRows])

	return {
		multiSelectConfig,
		selectedRowIndexes
	}
}